import React, { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  Text,
  IconButton,
  FormControl,
  FormLabel,
  Input,
  Button,
  SimpleGrid,
  useDisclosure,
  VStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Spinner,
  Center,
  Heading,
  Select,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import AdminSidebar from './AdminSidebar';
import { apiUrl } from '../ApiUrl/ApiUrl';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

function AdminSoftwares() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [imageFile, setImageFile] = useState(null);
  const [categoriess, setCategoriess] = useState([]);
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editingBook, setEditingBook] = useState(null);
  // const booksPerPage = 5;
  const [booksPerPage, setBooksPerPage] = useState(10); // Default rows per page
  const personName =localStorage.getItem("loginsetName");
  const [selectedCategory, setSelectedCategory] = useState("");
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!category) {
      alert("Please select a main category.");
      return;
    }
    if (!subCategory) {
      alert("Please select a sub-category.");
      return;
    }

  
    const formData = new FormData(e.target);
  
    if (imageFile) {
      formData.append('image', imageFile);
    }
    if (personName) {
      formData.append('person', personName); // ✅ already in use

    }
    try {
      const url = editingBook ? `${apiUrl}/public/updateBookById` : `${apiUrl}/public/savebook`;
      const method = editingBook ? 'PUT' : 'POST';
  
      if (editingBook) {
        formData.append('id', editingBook.id); // Include the book ID for updating
      }
  
      const response = await fetch(url, {
        method: method,
        body: formData,
      });
  
      if (response.ok) {
        alert(editingBook ? 'Product updated successfully!' : 'Product added successfully!');
        e.target.reset();
        setImageFile(null);
        setEditingBook(null); // Reset editing state
        AllBooks(); // Refresh the book list
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Error adding/updating product:', error);
      alert('Check All required Fields Then Please try again later.');
    }
  };
  const AllBooks = () => {
    fetch(`${apiUrl}/public/allSoftware`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      setBooks(data.reverse());
      setLoading(false);
    })
    .catch(error => {
      console.error('Error fetching books:', error);
      setLoading(false);
    });
  }

  useEffect(() => {
    AllBooks();
  }, []);
  const handleEdit = (book) => {
    setEditingBook(book); // Set the entire book object for editing
  };
  const handleDelete = (bookId) => {
    
    fetch(`${apiUrl}/public/deleteById?bid=${bookId}`, {
      method: 'DELETE',
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      alert("Deleted Successfully");
      AllBooks();
      return response.json();
    })
    .catch(error => {
      console.error('There was a problem with the delete request:', error);
    });
  };
  
  // Pagination logic
  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = books.slice(indexOfFirstBook, indexOfLastBook);

  const totalPages = Math.ceil(books.length / booksPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  useEffect(() => {
    fetch(`${apiUrl}/public/allCategories`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }
        return response.json();
      })
      .then((data) => setCategories(data))
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);


  const handleMainCategoryChange = (event) => {
    const selectedCategory = event.target.value;
    setCategory(selectedCategory);
    setSubCategory("");
    setSubCategories([]); // Clear subcategories when category changes

    fetch(`${apiUrl}/public/getsubCatByCatName?cname=${selectedCategory}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch subcategories");
        }
        return response.json();
      })
      .then((data) => setSubCategories(data))
      .catch((error) => console.error("Error fetching subcategories:", error));
  };



  useEffect(() => {
    // When editingBook changes, update the selected category
    if (editingBook) {
      setSelectedCategory(editingBook.searchcategory);
    }
  }, [editingBook]);
  
  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };


  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  useEffect(() => {
    // When editingBook changes, set the initial category value
    if (editingBook) {
      setCategory(editingBook.category);  // Set category based on editingBook
    }
  }, [editingBook]);
  






  return (
<>



    <Flex h="100%" bg="gray.100">
      <AdminSidebar />
      <Box flex="1" p={4}>
        <Flex justify="space-between" align="center" bg="white" p={4} mb={4} borderRadius="md" shadow="sm">
          <IconButton icon={<FiMenu />} aria-label="Open menu" display={{ base: 'block', md: 'none' }} onClick={onOpen} />
          <Text fontSize="xl" fontWeight="bold">
            Product Management
          </Text>
        </Flex>

        <Box bg="white" p={6} borderRadius="md" shadow="sm">
          <Text fontSize="lg" fontWeight="bold" mb={4}>
            Add New Product
          </Text>
          
          <form onSubmit={handleFormSubmit} encType="multipart/form-data">
            <SimpleGrid columns={4} spacing={4}>
              <FormControl id="booktitle" isRequired>
                <FormLabel>Product Name</FormLabel>
                <Input type="hidden" placeholder="Enter book id" name="id" defaultValue={editingBook ? editingBook.id : ''}/>
                <Input type="text" placeholder="Enter Product Name" name="booktitle" defaultValue={editingBook ? editingBook.booktitle : ''}/>
              </FormControl>
            
              <FormControl id="description" isRequired>
                <FormLabel>Description</FormLabel>
                <Input type="text" placeholder="Enter description" name="description" defaultValue={editingBook ? editingBook.description : ''}/>
              </FormControl>
              <FormControl id="image" isRequired>
                <FormLabel>Upload Image</FormLabel>
                <Input type="file" name="imageFile" accept="image/*" onChange={(e) => setImageFile(e.target.files[0])}   />
              </FormControl>
              <FormControl id="originalprice" isRequired>
                <FormLabel>Original Price</FormLabel>
                <Input type="number" placeholder="Enter original price" name="originalprice" defaultValue={editingBook ? editingBook.originalprice : ''}/>
              </FormControl>
              <FormControl id="descprice" isRequired>
                <FormLabel>Discounted Price</FormLabel>
                <Input type="number" placeholder="Enter discounted price" name="descprice" defaultValue={editingBook ? editingBook.descprice : ''}/>
              </FormControl>
 
    
             
              <FormControl id="hsn" >
                <FormLabel>HSN Number</FormLabel>
                <Input type="number" placeholder="Enter HSN" name="hsn" defaultValue={editingBook ? editingBook.hsn : ''}/>
              </FormControl>
 
             
              <FormControl id="maincatname" isRequired>
        <FormLabel>Select Category</FormLabel>
        <select name="maincatname" value={category} onChange={handleMainCategoryChange}>
          <option value="">Select Category</option>
          <option value="software">Softwares</option>
        
        </select>
      </FormControl>

      <FormControl id="subcatname" isRequired>
        <FormLabel>Select Sub Category</FormLabel>
        <select name="subcatname" value={subCategory} onChange={(e) => setSubCategory(e.target.value)} isRequired>
          <option value="">Select Sub Category</option>
          {subCategories.length > 0 ? (
            subCategories.map((sub) => (
              <option key={sub.subcatId} value={sub.subcatname}>
                {sub.subcatname}
              </option>
            ))
          ) : (
            <option value="">No subcategories available</option>
          )}
        </select>
      </FormControl>
      <FormControl id="searchcategory" isRequired  hidden>
        <FormLabel>Select Search Category</FormLabel>
        <select name="searchcategory" value={subCategory} onChange={(e) => setSubCategory(e.target.value)}>
          <option value="">Select Search Category</option>
          {subCategories.length > 0 ? (
            subCategories.map((sub) => (
              <option key={sub.subcatId} value={sub.subcatname}>
                {sub.subcatname}
              </option>
            ))
          ) : (
            <option value="">No subcategories available</option>
          )}
        </select>
      </FormControl>
            

    

    {/* Select Color */}
   

    {/* Select Material */}
   

            </SimpleGrid>
            <VStack mt={4} align="stretch">
              <Button type="submit" colorScheme="teal" width="full" >
                Add Product
              </Button>
            </VStack>
          </form>
        </Box>
      </Box>

    </Flex>

    <Box p={3}>
      <Heading as="h2" size="lg" mb={4}>Software List</Heading>
      {loading ? (
        <Center>
          <Spinner size="sm" />
        </Center>
      ) : (
        <>
          <TableContainer>
          <Flex justify="space-between" mb={4}>
<div className='flex gap-5'> 
<Select
          width="150px"
          value={booksPerPage}
          onChange={(e) => {
            setBooksPerPage(Number(e.target.value));
            setCurrentPage(1); // Reset to first page on change
          }}
        >
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="20">20 per page</option>
          <option value="50">50 per page</option>
        </Select>
 </div>
        
        <h1>Total Softwares : {currentBooks.length}</h1>


        {/* <Flex gap={2}>
          <Button onClick={prevPage} isDisabled={currentPage === 1}>
            Previous
          </Button>
          <Button onClick={nextPage} isDisabled={currentPage === totalPages}>
            Next
          </Button>
        </Flex> */}
      </Flex>
            <Table variant="striped" colorScheme="teal">
              <Thead>
                <Tr>
                  <Th>ID</Th>
                  <Th>Title</Th>
            
                  <Th>Original Price</Th>
                  <Th>Descounted Price</Th>
                
                  <Th>Category</Th>
                  <Th>Sub Category</Th>
                  <Th>Search Category</Th>
                  <Th>Entry By</Th>
                 
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentBooks.map(book => (
                  <Tr key={book.id}>
                    <Td>{book.id}</Td>
                    <Td>{book.booktitle}</Td>
             
                    <Td>{book.originalprice}</Td>
                    <Td>{book.descprice}</Td>
                   
                    <Td>{book.maincatname}</Td>
                    <Td>{book.subcatname}</Td>
                    <Td>{book.searchcategory}</Td>
                    <Td>{book.person ? book.person:'kstar'}</Td>
                   
                   
                    <Td>
                      <Flex gap={2}>
                        <IconButton
                          aria-label="Edit Book"
                          icon={<FiEdit />}
                          // onClick={() => handleEdit(book)}
                          onClick={() => {
                            handleEdit(book);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }}
                        />
                        <IconButton
                          aria-label="Delete Book"
                          icon={<FiTrash2 />}
                          colorScheme="red"
                          onClick={() => handleDelete(book.id)}
                        />
                      </Flex>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
          <Flex justify="space-between" mt={4}>
            <Button onClick={handlePreviousPage} disabled={currentPage === 1}>
              Previous
            </Button>
            <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
              Next
            </Button>
          </Flex>
        </>
      )}
    </Box>
</>
    
  );
}

export default AdminSoftwares;
